import { BaseEntity, Identifier } from '@okletsplay/core';
import { AsyncThunk } from '@reduxjs/toolkit';
import { dispatchUnwrap } from 'app/utils/store';
import React, {
  FC,
  memo,
  PropsWithChildren,
  ReactElement,
  useCallback,
  MouseEvent,
  useState,
} from 'react';

export interface BaseRequest {
  id: Identifier;
  payload: { isFeatured: boolean };
}

export function withFeatured<T, Returned, ThunkApiConfig, ThunkArg extends BaseRequest>(
  Component: FC<PropsWithChildren<T>>,
  update?: AsyncThunk<Returned, ThunkArg, ThunkApiConfig>
) {
  return memo(({ ...props }: T): ReactElement | null => {
    const [isLoading, setIsLoading] = useState(false);

    const onClickHandler = useCallback(
      (event: MouseEvent<HTMLDivElement>, data: BaseEntity & { isFeatured: boolean }) => {
        if (!update) {
          return;
        }

        event.stopPropagation();
        const payload = { id: data?.id, payload: { isFeatured: !data?.isFeatured } } as ThunkArg &
          BaseRequest;

        setIsLoading(true);
        dispatchUnwrap(update(payload), {}, true).finally(() => setIsLoading(false));
      },
      []
    );

    return <Component onClick={onClickHandler} isLoading={isLoading} {...props} />;
  });
}
